import { ChangeDetectionStrategy, Component, input, output, viewChild } from '@angular/core';
import { AlertComponent } from './alert.component';
import { DialogCloseDirective, DialogComponent, DialogOpenDirective } from './dialog/index';

@Component({
  selector: 'lib-alert-dialog',
  standalone: true,
  imports: [DialogComponent, DialogCloseDirective, DialogOpenDirective, AlertComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <lib-dialog #dialog>
      <lib-alert
        [title]="title()"
        [description]="description()"
        [confirmLabel]="confirmLabel()"
        [cancelLabel]="cancelLabel()"
        [variant]="variant()"
        (confirm)="confirm.emit()"
        (closed)="dialog.hide()" />
    </lib-dialog>
  `,
  host: {
    class: 'block',
  },
})
export class AlertDialogComponent {
  /** Unset (`undefined`) → `lib-alert` falls back to the `shared.alertDialog.*` translation. */
  title = input<string | undefined>(undefined);
  description = input<string | undefined>(undefined);
  confirmLabel = input<string | undefined>(undefined);
  cancelLabel = input<string | undefined>(undefined);
  variant = input<'default' | 'destructive'>('default');
  confirm = output<void>();
  dialog = viewChild<DialogComponent>('dialog');

  show() {
    this.dialog()?.show(); // ou .open() selon ton DialogComponent
  }

  hide() {
    this.dialog()?.hide();
  }
}
